import { Palette } from '@material-ui/core/styles/createPalette';

export const getMentionColors = (palette: Palette) => ({
  backgroundColor:
    palette.type === 'dark'
      ? 'rgba(179, 136, 255, 0.18)'
      : 'rgba(237, 231, 246, 1)',
  color: palette.type === 'dark' ? 'rgb(206, 147, 216)' : 'rgb(106, 27, 154)',
});
